<div class="version">
    <p [matTooltip]="buildDate" matTooltipPosition="above" >{{version}}.{{buildNumber}}</p>
</div>
